// eslint-disable-next-line no-use-before-define
type ErrorHandler = (error: V2Error) => void;

export default class V2Error extends Error {
  name: string;
  error: V2ErrorType | null;
  errorHandler?: ErrorHandler;

  constructor(error?: V2ErrorType, errorHandler?: ErrorHandler) {
    super();
    this.name = new.target.name; // new 연산자로 호출된 생성자의 이름
    this.error = error || null;
    this.errorHandler = errorHandler;
  }

  executeErrorHandler() {
    if (this.errorHandler) {
      // 에러 핸들러는 핸들링 대상 에러를 핸들러로 받음.
      this.errorHandler(this);
    }
  }
}
